<template>
  <nav class="bg-white dark:bg-gray-800 shadow-sm">
    <div class="container mx-auto px-4">
      <div class="flex justify-between items-center h-16">
        <div class="flex items-center space-x-8">
          <RouterLink to="/" class="text-xl font-bold text-gray-900 dark:text-white"> CAAS SDK </RouterLink>

          <!-- <div class="hidden md:flex space-x-6">
            <RouterLink
              v-for="route in routes"
              :key="route.path"
              :to="route.path"
              class="nav-link"
              active-class="text-caas-primary"
            >
              {{ route.name }}
            </RouterLink>
          </div> -->
        </div>

        <div class="flex items-center space-x-4">
          <WalletButton />
          <!-- <ThemeToggle /> -->
        </div>
      </div>
    </div>
  </nav>
</template>

<script setup lang="ts">
  import WalletButton from './WalletButton.vue';

  // const routes = [
  //   { name: 'Home', path: '/' },
  // ];
</script>

<style scoped>
  @reference '../style.css';
  .nav-link {
    @apply text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white px-3 py-2 rounded-md text-sm font-medium transition-colors;
  }
</style>
